import React from 'react';
import PropTypes from 'prop-types';

import { dig } from 'spiceutils';

import SingleYear from './SingleYear';
import MultipleYears from './MultipleYears';

const YearsToShow = (props) => {
  const updateCDF = (value) => {
    props.updateCDF('YearsToShow', value);
  };

  if (dig(props.controlList, ['YearsToShow', 'Visible']) === true) {
    switch (dig(props.controlList, ['YearsToShow', 'Type'])) {
      case 'select':
        return (
          <div>
            <label htmlFor="YearsToShow">Year to show</label>
            <SingleYear
              cdf={props.cdf}
              onChange={updateCDF}
              controlList={props.controlList.YearsToShow}
            />
          </div>
        );
      case 'multiSelect':
        return (
          <div>
            <label htmlFor="YearsToShow">Years to show</label>
            <MultipleYears
              cdf={props.cdf}
              onChange={updateCDF}
              controlList={props.controlList.YearsToShow}
            />
          </div>
        );
      default:
        return null;
    }
  }
  return null;
};

YearsToShow.propTypes = {
  cdf: PropTypes.object,
  controlList: PropTypes.object,
  updateCDF: PropTypes.func,
};

export default YearsToShow;



// WEBPACK FOOTER //
// ./app/components/FormControls/YearsToShow/index.js